import { render, staticRenderFns } from "./ContentQuestion.vue?vue&type=template&id=2ca82cff"
import script from "./ContentQuestion.vue?vue&type=script&lang=js"
export * from "./ContentQuestion.vue?vue&type=script&lang=js"
import style0 from "./ContentQuestion.vue?vue&type=style&index=0&id=2ca82cff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports